import { Navigate, Outlet } from 'react-router-dom'
import { routes } from '../constants'

const PublicRoutes = ({ isAuth }) => {
  return !isAuth ? <Outlet /> : <Navigate to={routes.registeredUsers} replace />
}

export default PublicRoutes
